import Hero from '../../components/Hero'
import { Link } from 'react-router-dom'
import './SpecializedCleaning.css'

const SpecializedCleaning = () => {
  return (
    <>
      <Hero 
        title="Specialised Cleaning"
        subtitle="Restore and maintain your facilities with expert services such as pressure washing, floor scrubbing, and detailed site cleaning."
        backgroundImage="/services/specialized/specialized.png"
        height="55.78125vh"
      />
      
      <section>
        <div className="section-header">
          <h2>Specialised Cleaning Services</h2>
        </div>
        <p>We provide tailored specialised cleaning solutions designed to restore, maintain, and enhance the presentation and safety of your facilities. From high-pressure washing to detailed floor care, our team uses advanced equipment and methods to deliver results that meet the highest industry standards.</p>
        <div className="grounds-grid">
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Pressure Washing</h3>
              <p>High-pressure water cleaning to remove dirt, grime, and stains from hard surfaces, restoring a fresh and professional appearance.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Rubbish &amp; Waste Removal</h3>
              <p>Efficient collection and disposal of general waste, bulky items, and site debris, keeping your premises clean, compliant, and hazard-free.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Hard Floor Scrubbing</h3>
              <p>Machine scrubbing and restoration for concrete, vinyl, and tiled floors, ensuring surfaces remain clean, safe, and well-maintained.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>High-Detail Cleaning</h3>
              <p>Thorough cleaning of hard-to-reach areas, fixtures, and fittings to maintain a spotless environment and meet compliance standards.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Car Park &amp; Exterior Cleaning</h3>
              <p>Comprehensive cleaning of car parks, pathways, and outdoor areas to enhance presentation and safety for staff and visitors.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Periodic Deep Cleaning</h3>
              <p>Scheduled intensive cleaning to refresh high-use areas, extend surface life, and maintain hygiene beyond routine services.</p>
            </article>
          </Link>
        </div>
      </section>
      
      <section className="cta-section">
        <h2>Keep Your Spaces at Their Best</h2>
        <p>Our specialised cleaning programs are tailored to your facility's unique needs, helping you maintain a safe, professional, and welcoming environment all year round.</p>
        <a className="cta-button" href="/contact">Enquire Now</a>
      </section>
    </>
  )
}

export default SpecializedCleaning
